import { connect } from 'react-redux';
import { fetchOnHoldReservations } from '../../../redux/Inventory/sagas/components/on-hold-reservations/routines';
import {
  getIsFetching,
  getIsSaving,
  getIsSaved,
  getOrder
} from '../../../redux/Inventory/selectors/components/on-hold-reservations';
import {
  clearOnHoldReservations,
  onHoldReservationsOnChangePage,
  onHoldReservationsOnChangeOrder
} from '../../../redux/Inventory/actions/components/on-hold-reservations';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Inventory/selectors/components/on-hold-reservations/pagination';
import { updateReservationStatus } from '../../../redux/Reservation/sagas/routines';
import { CANCEL } from '../../../constants/reservation/StatusActions';
import ReservationsWithOnholdItemList from '../../../components/inventory/ReservationsWithOnholdItemList';
import mergeListQueries from '../../../helpers/mergeListQueries';
import orderList from '../../../helpers/reservationOrderList';
import { hasPortalFeature } from '../../../helpers/config';
import { fetchSmtpAccounts } from '../../../redux/Settings/sagas/portal/smtp-account/routines';
import { SMTP_TYPES } from '../../../constants/smtp-account';
import { getHasActiveSmtpAccount } from '../../../redux/Settings/selectors/portal/smtp-account';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const order = getOrder(state);

  return {
    query: mergeListQueries(paginationQuery, {}, order),
    items: orderList(order, getCurrentPageItems(state)),
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isNotifyGuestEnabled: hasPortalFeature,
    isFetching: getIsFetching(state),
    isSaving: getIsSaving(state),
    isSaved: getIsSaved(state),
    hasActiveSmtpAccounts: getHasActiveSmtpAccount(state)
  };
}

function mapDispatchToProps(dispatch, { type, itemId, locationId, zoneId }) {
  const params = { type, id: itemId, locationId, zoneId };

  return {
    onInit: query => {
      dispatch(clearOnHoldReservations());
      dispatch(fetchOnHoldReservations({ ...params, ...query }));
      dispatch(fetchSmtpAccounts({ type: SMTP_TYPES.GMAIL }));
    },
    onReset: () => {
      dispatch(clearOnHoldReservations());
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded)
        dispatch(fetchOnHoldReservations({ ...params, ...query }));
      else dispatch(onHoldReservationsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearOnHoldReservations());
      dispatch(fetchOnHoldReservations({ ...params, ...query }));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearOnHoldReservations());
      dispatch(fetchOnHoldReservations({ ...params, ...query, order }));
      dispatch(onHoldReservationsOnChangeOrder(order));
    },
    onCancel: (id, notifyGuest, email, cancellationReason) => {
      const body = { notifyGuest, email, cancellationReason };
      dispatch(
        updateReservationStatus({
          id,
          body,
          statusAction: CANCEL,
          skipRedirect: true
        })
      );
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationsWithOnholdItemList);
